import React from 'react';
import { 
    Accordion, AccordionSummary, AccordionDetails, Typography, Box, 
    Button, Chip, Grid 
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterListIcon from '@mui/icons-material/FilterList';

const ActivityFilters = ({ 
    filters, 
    toggleFilter, 
    clearFilters, 
    activities, 
    uniqueStandsForFilter 
}) => {
    const years = [...new Set(activities.map(a => a.planned_year))].sort();
    const types = ['Planting', 'Clearing', 'Thinning', 'Final Felling'];
    const statuses = ['planned', 'in_progress', 'completed', 'cancelled'];
    const priorities = ['low', 'medium', 'high'];

    const hasFilters = Object.values(filters).some(f => f.length > 0);
    const safeStands = uniqueStandsForFilter || [];

    return (
        <Accordion sx={{ mb: 2 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Box display="flex" alignItems="center" gap={1}>
                    <FilterListIcon size="small" />
                    <Typography fontStyle="italic">Filters & Sorting</Typography>
                    {hasFilters && <Chip label="Active" color="primary" size="small" variant="outlined" />}
                </Box>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="caption" display="block" gutterBottom>Year</Typography>
                        <Box display="flex" flexWrap="wrap" gap={0.5}>
                            {years.map(y => (
                                <Chip 
                                    key={y} 
                                    label={y} 
                                    size="small" 
                                    color={filters.years.includes(y) ? "primary" : "default"}
                                    onClick={() => toggleFilter('years', y)}
                                />
                            ))}
                        </Box>
                    </Grid>
                    
                    <Grid item xs={12}>
                        <Typography variant="caption" display="block" gutterBottom>Activity Type</Typography>
                        <Box display="flex" flexWrap="wrap" gap={0.5}>
                            {types.map(t => (
                                <Chip 
                                    key={t} 
                                    label={t} 
                                    size="small" 
                                    color={filters.activityTypes.includes(t) ? "primary" : "default"}
                                    onClick={() => toggleFilter('activityTypes', t)}
                                />
                            ))}
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="caption" display="block" gutterBottom>Forest Stand</Typography>
                        <Box display="flex" flexWrap="wrap" gap={0.5}>
                            {safeStands.map(s => (
                                <Chip 
                                    key={s.id} 
                                    label={`Stand #${s.number}`} 
                                    size="small" 
                                    color={filters.standIds.includes(s.id) ? "primary" : "default"}
                                    onClick={() => toggleFilter('standIds', s.id)}
                                />
                            ))}
                        </Box>
                    </Grid>

                    <Grid item xs={12}>
                        <Button fullWidth variant="outlined" size="small" onClick={clearFilters}>
                            Clear All Filters
                        </Button>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default ActivityFilters;
